export default __webpack_public_path__ + "static/media/slider2.5ba9a11a.png";